// src/containers/Codes/usageCodes.js

import CodeSet from './CodeSet';

const usageCodes = new CodeSet('usage', { fr: 'utilisation', it: 'uso', es: 'uso', de: 'verwendung', da: 'anvendelse', nl: 'gebruik', no: 'bruk', sv: 'användning' });

// Interior (0)
usageCodes.addData(0, {
  name: { en: 'interior', fr: 'intérieur', it: 'interno', es: 'interior', de: 'innenbereich', da: 'indendørs', nl: 'interieur', no: 'innendørs', sv: 'inomhus' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' }
});

// Outdoor (1)
usageCodes.addData(1, {
  name: { en: 'outdoor', fr: 'extérieur', it: 'esterno', es: 'exterior', de: 'außenbereich', da: 'udendørs', nl: 'buiten', no: 'utendørs', sv: 'utomhus' },
  text: { 
    en: 'Enjoy the outdoors in style with our durable and weather-resistant outdoor rugs.', 
    fr: 'Profitez de l\'extérieur avec style grâce à nos tapis d\'extérieur durables et résistants aux intempéries.', 
    it: 'Goditi l\'aria aperta con stile con i nostri tappeti da esterno resistenti e resistenti alle intemperie.', 
    es: 'Disfruta del aire libre con estilo con nuestras alfombras de exterior duraderas y resistentes a la intemperie.', 
    de: 'Genießen Sie den Außenbereich mit Stil mit unseren langlebigen und wetterbeständigen Outdoor-Teppichen.', 
    da: 'Nyd udendørsområdet med stil med vores holdbare og vejrbestandige udendørstæpper.', 
    nl: 'Geniet in stijl van de buitenlucht met onze duurzame en weerbestendige buitentapijten.', 
    no: 'Nyt utendørs med stil med våre slitesterke og værbestandige utendørsteppene.', 
    sv: 'Njut av utomhusmiljön med stil med våra hållbara och väderbeständiga utomhusmattor.' 
  }
});

// Children (2)
usageCodes.addData(2, {
  name: { en: 'children', fr: 'enfants', it: 'bambini', es: 'niños', de: 'kinder', da: 'børn', nl: 'kinderen', no: 'barn', sv: 'barn' },
  text: { 
    en: 'Spark imagination with fun and playful kids\' rugs that are both stylish and practical.', 
    fr: 'Stimulez l\'imagination avec des tapis pour enfants amusants et ludiques qui sont à la fois élégants et pratiques.', 
    it: 'Accendi l\'immaginazione con tappeti per bambini divertenti e giocosi che sono sia eleganti che pratici.', 
    es: 'Estimula la imaginación con alfombras para niños divertidas y juguetonas que son tanto elegantes como prácticas.', 
    de: 'Wecken Sie die Fantasie mit lustigen und verspielten Kinderteppichen, die sowohl stilvoll als auch praktisch sind.', 
    da: 'Tænd fantasien med sjove og legende børnetæpper, der både er stilfulde og praktiske.', 
    nl: 'Stimuleer de verbeelding met leuke en speelse kindertapijten die zowel stijlvol als praktisch zijn.', 
    no: 'Tenn fantasien med morsomme og lekne barneteppene som både er stilige og praktiske.', 
    sv: 'Tänd fantasin med roliga och lekfulla barnmattor som är både stilfulla och praktiska.' 
  }
});

// Kitchen (3)
usageCodes.addData(3, {
  name: { en: 'kitchen', fr: 'cuisine', it: 'cucina', es: 'cocina', de: 'küche', da: 'køkken', nl: 'keuken', no: 'kjøkken', sv: 'kök' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' }
});

// Fireplace (4)
usageCodes.addData(4, {
  name: { en: 'fireplace', fr: 'cheminée', it: 'caminetto', es: 'chimenea', de: 'kamin', da: 'pejs', nl: 'open haard', no: 'peis', sv: 'eldstad' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' }
});

// Prayer (5)
usageCodes.addData(5, {
  name: { en: 'prayer', fr: 'prière', it: 'preghiera', es: 'rezo', de: 'gebet', da: 'bøn', nl: 'gebed', no: 'bønn', sv: 'bön' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' }
});


export default usageCodes;
